import PersonIcon from "components/icons/PersonIcon";
import ArrowDown from "components/icons/ArrowDown";
import { Menu, Dropdown, Spin } from "antd";
import { useRealmApp } from "RealmApp";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import s from "./styles";
import { useMessaging } from "context/MessagingContext";
import Colors from "assets/Colors";
import { useBusinessContext } from "../../../BusinessApp";

function Profile({ style }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logOut, currentUser } = useRealmApp();
  const { setErrorMessage } = useMessaging();

  const { rootUser, loading } = useBusinessContext();

  const lastName =
    (currentUser &&
      currentUser.customData &&
      currentUser.customData.lastName) ||
    rootUser?.lastName;

  const name =
    (currentUser && currentUser.customData && currentUser.customData.name) ||
    rootUser?.name;

  const email =
    currentUser?._profile?.data?.email ||
    (currentUser && currentUser.customData && currentUser.customData.email) ||
    "";

  function applyEmailStyle() {
    return {
      height: "40px",
      margin: "4px 0px",
      fontStyle: "italic",
      color: Colors.text_secondary,
      fontSize: "12px",
      borderRadius: "2px",
    };
  }

  const menu = (
    <Menu style={{ padding: "8px" }}>
      {email && (
        <Menu.Item key="0" disabled style={applyEmailStyle()}>
          {email}
        </Menu.Item>
      )}
      <Menu.Item
        key="1"
        onClick={() => {
          logOut()
            .then(() => {
              navigate("/");
            })
            .catch((err) => {
              setErrorMessage({ error: err });
            });
        }}
      >
        {t("containers.SideBarTopMenuHOC.Profile.exit")}
      </Menu.Item>
    </Menu>
  );
  return (
    <div style={style} onClick={(e) => e.stopPropagation()}>
      <Dropdown overlay={menu} trigger={["click"]}>
        <s.Wrapper>
          <s.PhotoWrapper>
            <PersonIcon />
          </s.PhotoWrapper>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "5px",
                marginLeft: "20px",
              }}
            >
              <Spin />
            </div>
          ) : (
            <s.RightElementsWrapper>
              <s.NameTextWrapper>
                {name} {lastName} <ArrowDown />
              </s.NameTextWrapper>
              <s.SubNameTextWrapper>
                {t("containers.SideBarTopMenuHOC.Profile.owner")}
              </s.SubNameTextWrapper>
            </s.RightElementsWrapper>
          )}
        </s.Wrapper>
      </Dropdown>
    </div>
  );
}

export default Profile;
